var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:[
        { 'light': _vm.light },
        _vm.inline ? 'relative' : 'absolute' ],style:({ height: _vm.size, width: _vm.size })})}
var staticRenderFns = []

export { render, staticRenderFns }